import { render } from "./SignupView.vue?vue&type=template&id=5efe7990"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/SignupView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5efe7990"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5efe7990', __exports__)) {
    api.reload('5efe7990', __exports__)
  }
  
  module.hot.accept("./SignupView.vue?vue&type=template&id=5efe7990", () => {
    api.rerender('5efe7990', render)
  })

}


export default __exports__